export default {
  valores: [
    {
      id: 'marcado',
      descricao: 'Marcado',
      anterior: [],
      proximo: ['assinado', 'faltou-sem-justificativa'],
      acao: 'agendamento_marcado',
    },
    {
      id: 'assinado',
      descricao: 'Assinado',
      anterior: ['marcado'],
      proximo: ['evoluido'],
      acao: 'agendamento_assinado',
    },
    {
      id: 'faltou-sem-justificativa',
      descricao: 'Falta Justificada',
      anterior: ['marcado'],
      proximo: [],
      acao: 'agendamento_faltou_sem_justificativa',
    },
    {
      id: 'evoluido',
      descricao: 'Evoluído',
      anterior: ['assinado'],
      proximo: [],
      acao: 'agendamento_evoluido',
    },
    {
      id: 'pre_agendado',
      descricao: 'Pré-agendado',
      anterior: [],
      proximo: [],
      acao: 'agendamento_pre_agendado',
    },
  ],
}
